import { graphql } from "../../gql";

export const ClassRoomPlanFragment = graphql(`
  fragment ClassRoomPlanFragment on UserClassRoomPlan {
    id
    userId
    startedAtWeekUtc
    endedAtWeekUtc
    lessonsPerWeek
    numberOfSlotIncluded
    planToRecoverId
    warrantyConfig {
      enabled
      minAttendedLessons
    }
    unlimitedLessonsPerWeekEnabled
    unlimitedLessonsPerWeekTotalLessons
    bonuses {
      type
      lessonsCountedPerWeek
      activeFrom
      activeTo
      extraLessons
      extraWeeks
    }
    mergeHistory {
      mergedAtUtc
      premergeEndedAtWeekUtc
      premergeTotalLessons
      triggeringOrderId
      promoIds
      bonuses {
        type
        lessonsCountedPerWeek
        activeFrom
        activeTo
        extraLessons
        extraWeeks
      }
    }
  }
`);
